<template>
  <a class="primary-600 pointer no-underline" :href="`mailto:${SUPPORT_EMAIL}`">
    {{ $t('Contact support') }}
  </a>
</template>

<script>
  import { SUPPORT_EMAIL } from '@/utils/constants/common';

  export default {
    name: 'ContactSupportLink',
    data() {
      return {
        SUPPORT_EMAIL,
      };
    },
  };
</script>
